export const ROWS = 10;
export const COLUMNS = 8;
export const SECTOR_LIMIT = 10;
export const MIN_DIMENSION = 5;
export const MAX_DIMENSION = 20;
export const LAYER_NAME_LENGTH = 40;
export const DEFAULT_HEX_WIDTH = 50; // Hex width when not rendering sector
export const HEX_PADDING = 2; // Pixels between hexes
export const EXTRA_HEXES = 1; // Extra hexes around canvas edges
export const PIXEL_BUFFER = 75; // Pixel buffer between the sector and window
export const MAX_HEXES = 1250; // Number of hexagons to render before this generator is short circuited
export const TARGET_COLOR_WIDTH = 11;
